var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"processSetting"}},[_c('set',{directives:[{name:"show",rawName:"v-show",value:(_vm.showPage==='set'),expression:"showPage==='set'"}],ref:"set",on:{"openDesigner":_vm.openDesigner}}),(_vm.showPage==='designer')?_c('flowEditor',{ref:"flowEditor",attrs:{"viewMode":_vm.viewMode},on:{"closeDesigner":_vm.close}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }